import { createSelector } from 'reselect';
import * as serviceProviderSelectors from './serviceProviderSelectors.js';
import { pipelineLeads } from './pipelineSelectors.js';
import { lead } from './querySelectors.js';
import { serviceProviderUsers } from './serviceProviderSelectors.js';

const stableArray = [];
const stableObject = {};

export const leads = createSelector(serviceProviderSelectors.serviceProvider, (serviceProvider) => serviceProvider.leads);
export const leadById = (leadId) => createSelector(leads, (leads) => leads.find((n) => n.id === leadId));
export const activeLeadId = lead;
export const activeLead = createSelector(lead, leads, (activeLeadId, leads) => leads.find((n) => n.id === activeLeadId));
export const activeLeadActivityRaw = createSelector(activeLead, (activeLead) => (activeLead || stableObject).activity || stableArray);
export const activeLeadActivity = createSelector(activeLeadActivityRaw, serviceProviderUsers, (activity, users) =>
  activity.map((n) => {
    const user = users.find((o) => o.id === n.userId) || stableObject;
    return {
      ...n,
      user: `${user.firstName || ''} ${user.lastName || ''}`.trim() || undefined,
      activity: true,
    };
  })
);
export const activeLeadServices = createSelector(activeLead, (activeLead) => (activeLead || stableObject).services || stableArray);

export const activeLeadContacts = createSelector(activeLead, (activeLead) => (activeLead || stableObject).contacts || stableArray);
export const activeLeadName = createSelector(activeLead, (activeLead) => `${(activeLead || {}).first_name || ''} ${(activeLead || stableObject).last_name || ''}`.trim());
export const activeLeadPipelineLeads = createSelector(activeLead, pipelineLeads, (activeLead, pipelineLeads) => {
  return pipelineLeads.filter((n) => n.lead_id === (activeLead || stableObject).id);
});
export const activeLeadSyncPlatforms = createSelector(lead, leads, (activeLeadId, leads) => {
  const lead = leads.find((n) => n.id === activeLeadId);
  return lead && lead.meta && (lead.meta.sync_platforms || []).length ? lead.meta.sync_platforms[0].platform_code : [];
});

export const activeLeadSyncPlatformLeadSyncId = createSelector(lead, leads, (activeLeadId, leads) => {
  const lead = leads.find((n) => n.id === activeLeadId);
  return lead && lead.meta && (lead.meta.sync_platforms || []).length ? lead.meta.sync_platforms[0].platform_registrations_sync_leads_id : [];
});

export const activeLeadNextechPayments = createSelector(lead, leads, (activeLeadId, leads) => {
  const lead = leads.find((n) => n.id === activeLeadId);
  return lead && lead.nextechPayments ? lead.nextechPayments : [];
});
